import { atom } from "recoil";
import { sessionStoragePersistRecoil } from "services/Local-services";
import { Routes } from "consts/Routes-App";

export const userInfo = atom({
    key: "userInfo",
    default: null,
});

export const miaServices = atom({
    key: "miaServices",
    default: [],
});

export const userCredentials = atom({
    key: "userCredentials",
    default: {},
});

export const rioNegroServices = atom({
    key: "rioNegroServices",
    default: [],
});

export const routeInfo = atom({
    key: "routeInfo",
    default: Routes.dashboard,
});

export const formIsOpen = atom({
    key: "formIsOpen",
    default: false,
});

export const rowSelected = atom({
    key: "rowSelected",
    default: {
        status: false,
        row: {},
    },
});

export const snackbarData = atom({
    key: "snackbarData",
    default: {
        open: false,
    },
});

export const formData = atom({
    key: "formData",
    default: {
        title: "",
    },
});

export const modalData = atom({
    key: "modalIsOpen",
    default: {
        isOpen: false,
        confirmationModalOpen: false,
        info: null,
        action: null,
        title: "",
    },
});

export const secondaryModalData = atom({
    key: "secondaryModalIsOpen",
    default: {
        isOpen: false,
        confirmationModalOpen: false,
        info: null,
        action: null,
        title: "",
    },
});

export const breadcrumbState = atom({
    key: "breadcrumbState",
    default: [],
    effects: [sessionStoragePersistRecoil("breadcrumb_state")],
});

export const paginationState = atom({
    key: "paginationState",
    default: 0,
});

export const userCoords = atom({
    key: "userCoords",
    default: null,
});

// Por que la ubicacion no esta disponible, para que el login pueda explicarlo. Los
// valores los define ESTADO_UBICACION en components/utils/useUbicacion.
export const ubicacionEstado = atom({
    key: "ubicacionEstado",
    default: "cargando",
});
